import React, { FC } from 'react';

import GenericSpinner from './GenericSpinner';
import { getColors, getType } from './spinnerUtil';

import './style.scss';

export interface LoaderProps {
    className?: string;
    ariaLabel?: string;
    mini?: boolean;
}

const Loader: FC<LoaderProps> = ({ className, ariaLabel = 'Vent Litt', mini }) => {
    const type = getType();
    return (
        <GenericSpinner
            className={className}
            ariaLabel={ariaLabel}
            mini={mini}
            colors={getColors()}
            stroke={type === 'constitution-day' ? 'grey' : undefined}
            roundedEdges={type !== 'constitution-day'}
        />
    );
};

export default Loader;
